import React from 'react'
import { Tag } from 'antd'
import { OrigemUserSituation } from 'ecpf/models/OrigemModel'

export const SituationOrigemTag = ({ situation }: {situation: OrigemUserSituation}) =>
  <Tag color={situation === OrigemUserSituation.Ativo ? 'blue' : 'red'}>{situation}</Tag>
